import { useCallback, useSyncExternalStore } from 'react';

const KEY = 'portal.recent-pages';
const MAX = 8;
const listeners = new Set<() => void>();

function read(): string[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '[]') as string[];
  } catch {
    return [];
  }
}

let snapshot = read();

/** Remembers a visited page (navigation id), most recent first. Kept in this browser only. */
export function rememberPage(navId: string): void {
  const next = [navId, ...snapshot.filter((id) => id !== navId)].slice(0, MAX);
  if (next.join() === snapshot.join()) return;
  snapshot = next;
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Not persisted when storage is unavailable.
  }
  listeners.forEach((l) => l());
}

export function useRecentPages(): string[] {
  const subscribe = useCallback((listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, []);
  return useSyncExternalStore(subscribe, () => snapshot);
}
